import { Box, Text, Tooltip } from '@wix/design-system';
import Image from 'next/image';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DATA_HOOKS } from '../../../dataHooks';

import css from './index.module.scss';

interface CopilotButtonProps {
  onClick: () => void;
}

export const CopilotButton = ({ onClick }: CopilotButtonProps) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const aiIcon = `https://static.parastorage.com/services/kb-client-nextjs/dist/public/images/icons/sparkles${isHovered ? '-hovered' : ''}.svg`;

  return (
    <div
      onClick={onClick}
      data-hook={DATA_HOOKS.COPILOT_BUTTON}
      className={css.copilotButton}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Tooltip content={t('article-page.copilot.tooltip')} enterDelay={300} size="small" moveBy={{ y: 12 }}>
        <Box align="center" verticalAlign="middle" gap="12px">
          <Image src={aiIcon} alt='ai' width='18' height='18' />
          <Text size="small">{t('article-page.copilot')}</Text>
        </Box>
      </Tooltip>
    </div>
  );
};
